'use strict';

angular.module('imagetrend.components')
    .directive('multipleAutocomplete', [
        '$rootScope',
        '$filter',
        '$http',
        function ($rootScope, $filter, $http) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope : {
                    suggestionsArr : '=?',
                    modelArr : '=ngModel',
                    apiUrl : '@',
                    beforeSelectItem : '=?',
                    afterSelectItem : '=?',
                    beforeRemoveItem : '=?',
                    afterRemoveItem : '=?',
                    onChangeFunction: '&?',
                    question: '=?',
                    optionsLoaded: '=?',
                    existingLoaded: '=?',
                    selectedOptions: '=?'
                },
                templateUrl: 'templates/multiple-autocomplete/multiple-autocomplete.html',
                link : function(scope, element, attr, ngModel){
                    scope.objectProperty = attr.objectProperty;
                    scope.selectedItemIndex = 0;
                    scope.name = attr.name;
                    scope.isRequired = attr.isRequired;
                    scope.errMsgRequired = attr.errMsgRequired;
                    scope.isDisabled = attr.disable;
                    scope.isOpen = false;
                    if (!scope.isDisabled) { scope.isDisabled = false; } else { if (scope.isDisabled == 'true' || scope.isDisabled == true) { scope.isDisabled = true; } else { scope.isDisabled = false; } }
                    if (!scope.isRequired) { scope.isRequired = false; } else { if (scope.isRequired == 'true' || scope.isRequired == true) { scope.isRequired = true; } else { scope.isRequired = false; } }

                    var getSuggestionsList = function () {
                        var url = scope.apiUrl;
                        $http({
                            method: 'GET',
                            url: url
                        }).then(function (response) {
                            scope.suggestionsArr = response.data;
                        }, function (response) {
                            console.log("*****Angular-multiple-select **** ----- Unable to fetch list");
                        });
                    };

                    if(scope.suggestionsArr == null || scope.suggestionsArr == ""){
                        if (scope.apiUrl != null && scope.apiUrl != "") {
                            getSuggestionsList();
                        } 
                    }

                    if(scope.modelArr == null || scope.modelArr == ""){
                        scope.modelArr = [];
                    }

                    scope.$watch("existingLoaded", function (existingLoaded) {
                        if (existingLoaded) {
                            //Setting the selected options after any api calls have been completed
                            if (scope.selectedOptions && angular.isArray(scope.selectedOptions)) {
                                ngModel.$setViewValue(scope.selectedOptions);
                            }
                        }
                    });

                    scope.onBlur = function (event) {
                        if (!event.relatedTarget || !event.relatedTarget.classList.contains('autocomplete-list')) {
                            scope.isOpen = false;
                        }
                        else {
                            event.target.focus();
                        }
                    };

                    scope.onChange = function () {
                        scope.selectedItemIndex = 0;
                    };

                    scope.toggleOpen = function () {
                        scope.isOpen = !scope.isOpen;
                    };  

                    scope.keyParser = function ($event) {
                        var keys = {
                            38: 'up',
                            40: 'down',
                            8 : 'backspace',
                            13: 'enter',
                            9 : 'tab',
                            27: 'esc'
                        };
                        var key = keys[$event.keyCode];
                        if(key == 'backspace' && scope.inputValue == ""){
                            if(scope.modelArr.length != 0){
                                scope.removeAddedValues(scope.modelArr[scope.modelArr.length-1]);
                                //scope.modelArr.pop();
                            }
                        }
                        else if(key == 'down'){
                            var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                            filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                            if(scope.selectedItemIndex < filteredSuggestionArr.length -1)
                                scope.selectedItemIndex++;
                        }
                        else if(key == 'up' && scope.selectedItemIndex > 0){
                            scope.selectedItemIndex--;
                        }
                        else if(key == 'esc'){
                            scope.isOpen = false;
                        }
                        else if(key == 'enter'){
                            //When the multi-select is on a form, this will stop it from accidentally going to the next page or submitting the form when enter is pressed
                            $event.preventDefault();

                            var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                            filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                            if(scope.selectedItemIndex < filteredSuggestionArr.length)
                                scope.onSuggestedItemsClick(filteredSuggestionArr[scope.selectedItemIndex]);
                        }
                    };

                    scope.onSuggestedItemsClick = function (selectedValue) {
                        if(scope.beforeSelectItem && typeof(scope.beforeSelectItem) == 'function')
                            scope.beforeSelectItem(selectedValue);

                        scope.modelArr.push(selectedValue);

                        if(scope.afterSelectItem && typeof(scope.afterSelectItem) == 'function')
                            scope.afterSelectItem(selectedValue);

                        if(scope.onChangeFunction && typeof(scope.onChangeFunction) == 'function')
                            scope.onChangeFunction(scope.modelArr);

                        scope.inputValue = "";
                    };

                    var isDuplicate = function (arr, item) {
                        var duplicate = false;
                        if(arr == null || arr == "")
                            return duplicate;

                        for(var i=0;i<arr.length;i++){
                            duplicate = angular.equals(arr[i], item);
                            if(duplicate)
                                break;
                        }
                        return duplicate;
                    };

                    scope.alreadyAddedValues = function (item) {
                        var isAdded = true;
                        isAdded = !isDuplicate(scope.modelArr, item);
                        return isAdded;
                    };

                    scope.removeAddedValues = function (item) {
                        if(scope.modelArr != null && scope.modelArr != "") {
                            var itemIndex = scope.modelArr.indexOf(item);
                            if (itemIndex != -1) {
                                if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                    scope.beforeRemoveItem(item);

                                scope.modelArr.splice(itemIndex, 1);

                                if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                    scope.afterRemoveItem(item);

                                if(scope.onChangeFunction && typeof(scope.onChangeFunction) == 'function')
                                    scope.onChangeFunction(scope.modelArr);
                            }
                        }
                    };

                    scope.mouseEnterOnItem = function (index) {
                        scope.selectedItemIndex = index;
                    };

                    //Extra validation to prevent form submission if the field is required and no items are selected but text is typed in
                    scope.$watch('modelArr.length', function (newValue, oldValue) {
                        if (scope.isRequired) {
                            ngModel.$setValidity('required', newValue > 0);
                        }
                    });  
                }
            };
        }
    ])
;